import Vue from 'vue'
// import VeeValidate from "vee-validate";
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue'
import { store } from './store/store'

import 'bootstrap-scss/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'fontawesome-4.7/scss/font-awesome.scss';
import './assets/scss/common.scss';
import VueSimpleAlert from "vue-simple-alert";
import Vuelidate from 'vuelidate';
// Comment

Vue.use(Vuelidate);
Vue.use(VueSimpleAlert);

import App from './views/App.vue'
import router from './router'
import i18n from './i18n'

Vue.config.productionTip = false
// Vue.use(VeeValidate, {
//   inject: true,
//   fieldsBagName: "veeFields",
//   errorBagName: "veeErrors"
// });
Vue.use(BootstrapVue)
Vue.use(VueSimpleAlert);
Vue.use(ToastPlugin);

new Vue({
  store: store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

// Set default values
// i18n.locale = "ar";
document.documentElement.style.setProperty(`--client-brand-color`, '#BF4804');